module.exports = __webpack_public_path__ + "static/media/phoneChange.bcfd5be3.svg";